import React from 'react'

import CasinoDisabledIcon from '../../../images/casino_disabled_icon.svg'
import { useTranslation } from '../../../context/translationProvider'
import { Button } from '../../atoms/button'
import { autoWithdrawalOptOut } from '../../../adapters/user'
import { toast } from '../../atoms'
import {
  StyledAutoWDConfirmationContent,
  StyledAutoWDConfirmationModal,
  StyledButtonsContainer,
} from './styles'

const AutoWDConfirmationModal = ({ casinoBackLink }) => {
  const { translate } = useTranslation()

  const handleOptOut = async () => {
    const { data } = await autoWithdrawalOptOut()
    if (data?.messageCode === 1) {
      toast.success(translate('account.autoWD.confirm.disable.success'))
      window.location.reload()
    }
  }

  return (
    <StyledAutoWDConfirmationModal>
      <StyledAutoWDConfirmationContent>
        <h3>{translate('account.autoWD.confirm.disable.title')}</h3>

        <img src={CasinoDisabledIcon} height={100} />
        <p>{translate('account.autoWD.confirm.disable.description')}</p>
      </StyledAutoWDConfirmationContent>

      <StyledButtonsContainer>
        <Button onClick={handleOptOut}>
          {translate('account.autoWD.confirm.disable.confirmButtonLabel')}
        </Button>
        <Button bordered dark href={casinoBackLink}>
          {translate('common.cancel')}
        </Button>
      </StyledButtonsContainer>
    </StyledAutoWDConfirmationModal>
  )
}

export { AutoWDConfirmationModal }
